export default __webpack_public_path__ + "waves-two-columns-section.svg";